import React from 'react';
import { NavLink } from 'react-router-dom'



const Footer = () => {

    const SubmitHandler = (e) => {
        e.preventDefault()
    }
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <footer className="ico_site_footer section_decoration section_shadow_top" style={{ fontFamily: '"DM Sans", serif' }}>
            {/* <div className="decoration_item shape_top">
                <img src={shapeIconBottom} alt="Bottom Line Shape" />
            </div> */}
            <div className="container">

                <div className="footer_bottom text-center">
                    <p className="copyright_text m-0 text-white">Copyright© 2025 TopCoin LTD. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
